import { render, staticRenderFns } from "./homeT.vue?vue&type=template&id=66bbd4fd&scoped=true"
import script from "./homeT.vue?vue&type=script&lang=js"
export * from "./homeT.vue?vue&type=script&lang=js"
import style0 from "./homeT.vue?vue&type=style&index=0&id=66bbd4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbd4fd",
  null
  
)

export default component.exports